import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@icons/myicons/trash-delete-bin-2.svg?react";
import ErrorIcon from "@icons/myicons/error-filled.svg?react";
import SuccessIcon from "@icons/myicons/check-circle-filled.svg?react";

export const UploadStatus = ({
  status,
  fileName,
  onFileDelete,
}: {
  status: "success" | "fail";
  fileName: string;
  onFileDelete: (event: React.MouseEvent) => void;
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={3}
      width="100%"
      justifyContent="center"
    >
      <Box
        display="flex"
        alignItems="center"
        flexShrink={0}
        color={status === "success" ? "icon.success" : "icon.error"}
      >
        {status === "success" ? <SuccessIcon /> : <ErrorIcon />}
      </Box>
      <Typography variant="body3" noWrap maxWidth="300px">
        {fileName}
      </Typography>
      <IconButton
        onClick={onFileDelete}
        size="small"
        sx={{
          cursor: "pointer",
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};
